<template>
  <section class="confirm">
    <h1 class="confirm__message">Your account is being set up...</h1>
    <div class="confirm__spinner-wrapper">
      <ActionLoader name="ball-clip-rotate" />
    </div>
  </section>
</template>

<script>
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'confirm',
  components: {
    ActionLoader,
  },
  metaInfo() {
    return {
      title: `INE - Account Confirmation`,
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return {
      code: '',
      username: '',
    }
  },
  methods: {
    handleParams(params) {
      const code = params.get('code')
      const username = params.get('username')
      if (!code || !username) {
        this.$router.push({ name: 'login' })
        this.$store.dispatch(
          'app/setError',
          'There was an error, please try again.'
        )
      } else {
        this.code = code
        this.username = username
      }
    },
    async confirmAccount() {
      const { code, username } = this
      this.$store.dispatch('auth/confirmNewAccount', { code, username })
    },
  },
  async created() {
    this.handleParams(new URLSearchParams(window.location.search))
    await this.confirmAccount()
  },
}
</script>

<style lang="scss" scoped>
.confirm {
  background-color: var(--light-gray);
  padding-top: 300px;
  &__message {
    margin: 0 auto;
    text-align: center;
    color: var(--white);
    font-size: 2rem;
  }
  &__spinner-wrapper {
    width: 100%;
    color: var(--orange);
    margin: 20px auto 0 auto;
    text-align: center;
  }
}
</style>
